// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__ssIZh","list":"PatternAutocomplete_list__3Dd0v"};